import { Box, Center } from '@chakra-ui/react';
import React from 'react';
import { ContactForm } from '../components';

const Contact = () => {
  return (
    <Box>
      <Center>
        <ContactForm />
      </Center>
    </Box>
  );
};

export default Contact;
